import { render } from "./SeparatorV.vue?vue&type=template&id=2b8c2b36&scoped=true"
const script = {}

import "./SeparatorV.vue?vue&type=style&index=0&id=2b8c2b36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8c2b36"]])

export default __exports__